import { createSlice } from "@reduxjs/toolkit";
import { CartSliceProp, CartType } from "../../Type/Application/Ecommerce/Product";
import { toast } from "react-toastify";

const initialState: CartSliceProp = {
  cart: [],
  total: null,
  tax: 10
};

const CartSlice = createSlice({
  name: "CartSlice",
  initialState,
  reducers: {
    incrementData: (state, action) => {
      const productId = action.payload.item.id;
      state.cart = state.cart.map((item) => {
        if (productId === item.id) {
          if (item.total == item.quantite_stock) {
            toast.info('la quantite demandée est trop, Veuillez faire un approvisionnement')
            return item
          }
          return { ...item, total: item.total + 0.5, sum: item.prix_unitaire * (item.total + 0.5) };
        } else {
          return item;
        }
      });
    },

    decrementData: (state, action) => {
      state.cart = state.cart.map((item) => (action.payload === item.id && item.total > 0.5 ? { ...item, total: item.total - 0.5, sum: item.prix_unitaire * (item.total - 0.5) } : item));
    },

    removeCartData: (state, action) => {
      state.cart = state.cart.filter((item) => item.id !== action.payload);
    },

    clearCart: (state) => {
      state.cart = [];
    },

    addToCartData: (state, action) => {
      const productId = action.payload.item.id;
      if (state.cart.findIndex((product) => product.id === productId) !== -1) {
        state.cart = state.cart.reduce((cartAcc: CartType[], product) => {
          if (product.id === productId) {
            cartAcc.push({ ...product, total: product.total + action.payload.quantity, sum: product.prix_unitaire * (product.total + action.payload.quantity) });
          } else {
            cartAcc.push(product);
          }
          return cartAcc;
        }, []);
      } else {
        state.cart = [...state.cart, { ...action.payload.item, total: action.payload.quantity, sum: action.payload.item.prix_unitaire * action.payload.item.total }];
      }
    },
    setTotal: (state, action) => {
      state.total = action.payload
    }
  },
});
export const { incrementData, clearCart, decrementData, removeCartData, addToCartData, setTotal } = CartSlice.actions;

export default CartSlice.reducer;